import React from "react";
import { Wrapper, SectionHeading } from "@gw/component-library";
import { BaseLayout } from "../../layouts";
import { UserList } from "../../components";
import { UserListPageStyled } from "./UserListPageStyled";
var UserListPage = function (props) {
    return (React.createElement(BaseLayout, null,
        React.createElement(UserListPageStyled, null,
            React.createElement(Wrapper, { className: "wrapper my-50" },
                React.createElement(SectionHeading, null, "User List"),
                React.createElement(UserList, null)))));
};
export default UserListPage;
//# sourceMappingURL=UserListPage.js.map